// =============================
// Consultation Modal Handler
// =============================

document.addEventListener('DOMContentLoaded', function() {
		// Handle 'Pick a time for us to give you a call' link click
	document.addEventListener('click', function(e) {
		const pickTimeLink = e.target.closest('a');
		if (pickTimeLink && pickTimeLink.matches('.question-prompt-book a')) {
			e.preventDefault();
			const intentBooking = document.getElementById('intent-booking');
			if (intentBooking) {
				intentBooking.checked = true;
				intentBooking.dispatchEvent(new Event('change'));
			}
		}
	});

	// Close modal when fallback booking link is clicked
	document.addEventListener('click', function(e) {
		const fallbackLink = e.target.closest('.iframe-fallback a');
		if (fallbackLink) {
			closeModal();
		}
	});
	
    // Lightweight input mask for Australian mobile numbers (04XX XXX XXX)
    function attachPhoneInputMask() {
        const phoneInputMask = document.getElementById('modal-phone');
        if (!phoneInputMask) return;
        // Remove previous listener if any
        phoneInputMask.removeEventListener('input', phoneInputMask._maskHandler || (()=>{}));
        // Define handler
        function maskHandler(e) {
            let digits = phoneInputMask.value.replace(/\D/g, '');
            digits = digits.substring(0, 10);
            let formatted = '';
            if (digits.length > 0) {
                formatted += digits.substring(0, 4);
            }
            if (digits.length > 4) {
                formatted += ' ' + digits.substring(4, 7);
            }
            if (digits.length > 7) {
                formatted += ' ' + digits.substring(7, 10);
            }
            phoneInputMask.value = formatted.trim();
        }
        phoneInputMask.addEventListener('input', maskHandler);
        phoneInputMask._maskHandler = maskHandler;
        // On form submit, strip spaces before sending
        const form = phoneInputMask.closest('form');
        if (form && !form._phoneMaskSubmitHandler) {
            form.addEventListener('submit', function() {
                phoneInputMask.value = phoneInputMask.value.replace(/\s+/g, '');
            });
            form._phoneMaskSubmitHandler = true;
        }
    }
    const modal = document.getElementById('consultationModal');

    // Function to open the modal
    function openModal() {
        if (modal) {
            modal.classList.add('active');
            const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
            document.body.style.overflow = 'hidden';
            document.body.style.marginRight = scrollBarWidth + 'px';

            // Always reset to booking view if booking tab is selected
            if (intentBooking && intentBooking.checked && typeof switchToBooking === 'function') {
                switchToBooking();
            } else if (intentQuestion && intentQuestion.checked && typeof switchToQuestion === 'function') {
                switchToQuestion();
            }

            // Always scroll modal-form to top
            const modalForm = modal.querySelector('.modal-form');
            if (modalForm) {
                modalForm.scrollTo({ top: 0, behavior: 'auto' });
                // Move focus to the first focusable element in the modal form (not the close button)
                const focusableSelectors = [
                    'input:not([type="hidden"]):not([disabled]):not([tabindex="-1"])',
                    'select:not([disabled]):not([tabindex="-1"])',
                    'textarea:not([disabled]):not([tabindex="-1"])',
                    'button:not([disabled]):not([tabindex="-1"])',
                    'a[href]:not([tabindex="-1"])',
                    '[tabindex]:not([tabindex="-1"])',
                    '[contenteditable="true"]'
                ];
                const firstFormFocusable = modalForm.querySelector(focusableSelectors.join(','));
                if (firstFormFocusable) {
                    firstFormFocusable.focus();
                } else {
                    // Fallback: focus modal form container for screen readers
                    modalForm.focus();
                }
            } else {
                // Fallback: focus modal container for screen readers
                modal.focus();
            }
        }
    }

    // Function to close the modal
    function closeModal() {
        if (modal) {
            modal.classList.remove('active');
            document.body.style.overflow = '';
            document.body.style.marginRight = '';
        }
    }

    // Add click handlers to trigger buttons
    document.querySelectorAll('[data-modal-trigger]').forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            openModal();
        });
    });

    // Close modal when clicking overlay
    if (modal) {
        const overlay = modal.querySelector('.modal-overlay');
        if (overlay) {
            overlay.addEventListener('click', closeModal);
        }
    }

    // Close modal when clicking close button
    document.querySelectorAll('.modal-close').forEach(button => {
        button.addEventListener('click', closeModal);
    });

    // Close modal on escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            closeModal();
        }
    });

    // Handle contact method switching for question mode (email/phone tabs)
    const emailTab = document.getElementById('modal-email-tab');
    const phoneTab = document.getElementById('modal-phone-tab');
    const emailInput = document.getElementById('modal-email');
    const phoneInput = document.getElementById('modal-phone');
    const contactMethodInput = document.getElementById('modal-contact-method');
    
    if (emailTab && phoneTab && emailInput && phoneInput) {
        emailTab.addEventListener('change', function() {
            emailInput.classList.add('active');
            phoneInput.classList.remove('active');
            emailInput.setAttribute('required', 'required');
            phoneInput.removeAttribute('required');
            if (contactMethodInput) contactMethodInput.value = 'email';
            emailInput.setAttribute('name', 'Email');
            phoneInput.value = '';
            attachPhoneInputMask();
        });

        phoneTab.addEventListener('change', function() {
            phoneInput.classList.add('active');
            emailInput.classList.remove('active');
            phoneInput.setAttribute('required', 'required');
            emailInput.removeAttribute('required');
            if (contactMethodInput) contactMethodInput.value = 'phone';
            emailInput.removeAttribute('name');
            emailInput.value = '';
            attachPhoneInputMask();
        });

        // On load, ensure correct required state
        if (emailTab.checked) {
            emailInput.setAttribute('required', 'required');
            phoneInput.removeAttribute('required');
            emailInput.setAttribute('name', 'Email');
            attachPhoneInputMask();
        } else if (phoneTab.checked) {
            phoneInput.setAttribute('required', 'required');
            emailInput.removeAttribute('required');
            emailInput.removeAttribute('name');
            attachPhoneInputMask();
        }
    }

    // Handle intent switching (booking vs question)
    const intentBooking = document.getElementById('intent-booking');
    const intentQuestion = document.getElementById('intent-question');
    const questionField = document.getElementById('question-field');
    const timeSlotsField = document.getElementById('time-slots-field');
    const optionalSection = document.getElementById('optional-section');
    const modalDescription = document.getElementById('modal-description');
    const submitBtn = document.getElementById('modal-submit-btn');
    const messageTextarea = document.getElementById('modal-message');
    const timeSlotInputs = document.querySelectorAll('input[name="timeSlot"]');
    const visualTitle = document.getElementById('modal-visual-title');
    const visualBenefits = document.getElementById('modal-visual-benefits');
    const bookingContactFields = document.getElementById('booking-contact-fields');
    const questionContactFields = document.getElementById('question-contact-fields');

    // Track pending timeouts to prevent overlapping animations
    let pendingTimeouts = [];

    function clearPendingTimeouts() {
        pendingTimeouts.forEach(timeout => clearTimeout(timeout));
        pendingTimeouts = []; 
    }

    function scrollConsultationModalToTop() {
        const modal = document.getElementById('consultationModal');
        if (modal) {
            // On mobile, scroll the modal-container; on desktop, scroll the modal-form
            const modalContainer = modal.querySelector('.modal-container');
            const modalForm = modal.querySelector('.modal-form');
            if (window.innerWidth <= 992 && modalContainer) {
                modalContainer.scrollTo({ top: 0, behavior: 'smooth' });
            } else if (modalForm) {
                modalForm.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }
    }

    function switchToBooking() {
        // Clear any pending animation timeouts
        clearPendingTimeouts();
        
        if (questionField) {
            questionField.style.opacity = '0';
            pendingTimeouts.push(setTimeout(() => {
                questionField.style.display = 'none';
            }, 300));
        }
        if (questionContactFields) {
            questionContactFields.style.opacity = '0';
            pendingTimeouts.push(setTimeout(() => {
                questionContactFields.style.display = 'none';
            }, 300));
        }
        if (bookingContactFields) {
            bookingContactFields.style.display = 'block';
            pendingTimeouts.push(setTimeout(() => {
                bookingContactFields.style.opacity = '1';
            }, 10));
        }
        if (timeSlotsField) {
            timeSlotsField.style.display = 'block';
            pendingTimeouts.push(setTimeout(() => {
                timeSlotsField.style.opacity = '1';
            }, 10));
        }
        if (optionalSection) {
            optionalSection.style.display = 'block';
            pendingTimeouts.push(setTimeout(() => {
                optionalSection.style.opacity = '1';
            }, 10));
        }
        if (modalDescription) modalDescription.textContent = "We'll call you at a time that works for you";
        if (submitBtn) submitBtn.textContent = 'Book Free Consultation';
        
        // Update visual panel
        if (visualTitle) visualTitle.textContent = 'Free 15-Minute Chat';
        if (visualBenefits) {
            visualBenefits.innerHTML = `
                <li><i class="fas fa-check"></i> No commitment needed</li>
                <li><i class="fas fa-check"></i> Completely confidential</li>
                <li><i class="fas fa-check"></i> Choose a time that suits you</li>
            `;
        }
        
        // Update required fields
        if (messageTextarea) messageTextarea.removeAttribute('required');
        timeSlotInputs.forEach(input => input.setAttribute('required', 'required'));
        
        // Scroll modal to top
        scrollConsultationModalToTop();
    }

    function switchToQuestion() {
        // Clear any pending animation timeouts
        clearPendingTimeouts();
        
        if (timeSlotsField) {
            timeSlotsField.style.opacity = '0';
            pendingTimeouts.push(setTimeout(() => {
                timeSlotsField.style.display = 'none';
            }, 300));
        }
        if (optionalSection) {
            optionalSection.style.opacity = '0';
            pendingTimeouts.push(setTimeout(() => {
                optionalSection.style.display = 'none';
            }, 300));
        }
        if (bookingContactFields) {
            bookingContactFields.style.opacity = '0';
            pendingTimeouts.push(setTimeout(() => {
                bookingContactFields.style.display = 'none';
            }, 300));
        }
        if (questionField) {
            questionField.style.display = 'block';
            pendingTimeouts.push(setTimeout(() => {
                questionField.style.opacity = '1';
            }, 10));
        }
        if (questionContactFields) {
            questionContactFields.style.display = 'block';
            pendingTimeouts.push(setTimeout(() => {
                questionContactFields.style.opacity = '1';
            }, 10));
        }
        if (modalDescription) modalDescription.textContent = 'Ask us anything - no commitment needed';
        if (submitBtn) submitBtn.textContent = 'Send Question';
        
        // Update visual panel
        if (visualTitle) visualTitle.textContent = 'We\'re Here to Help';
        if (visualBenefits) {
            visualBenefits.innerHTML = `
                <li><i class="fas fa-check"></i> Quick response</li>
                <li><i class="fas fa-check"></i> No obligation</li>
                <li><i class="fas fa-check"></i> Completely confidential</li>
            `;
        }
        
        // Update required fields
        if (messageTextarea) messageTextarea.setAttribute('required', 'required');
        timeSlotInputs.forEach(input => input.removeAttribute('required'));
        
        // Scroll modal to top
        scrollConsultationModalToTop();
    }

    if (intentBooking && intentQuestion) {
        intentBooking.addEventListener('change', function() {
            if (this.checked) switchToBooking();
        });
        
        intentQuestion.addEventListener('change', function() {
            if (this.checked) switchToQuestion();
        });
    }

    // Handle form submission via AJAX
    const consultationForm = document.querySelector('.consultation-form');
    if (consultationForm) {
        consultationForm.addEventListener('submit', async function(e) {
            e.preventDefault(); // Prevent default form submission
            
            // Get the submit button and disable it to prevent double submissions
            const submitButton = consultationForm.querySelector('button[type="submit"]');
            const originalButtonText = submitButton ? submitButton.textContent : '';
            if (submitButton) {
                submitButton.disabled = true;
                submitButton.textContent = 'Sending...';
            }
            
            // Show loading overlay
            const loadingOverlay = document.getElementById('formLoadingOverlay');
            if (loadingOverlay) {
                loadingOverlay.classList.add('active');
            }
            
            // Clear any previous messages
            const existingMessage = document.getElementById('modal-feedback-message');
            if (existingMessage) {
                existingMessage.remove();
            }
            
            try {
                // Get form data
                const formData = new FormData(consultationForm);
                
                // Submit the form via fetch
                const response = await fetch('/Question/Submit', {
                    method: 'POST',
                    body: formData
                });
                
                const result = await response.json();
                
                // Hide loading overlay
                if (loadingOverlay) {
                    loadingOverlay.classList.remove('active');
                }
                
                if (response.ok) {
                    // Success - close modal immediately and show toast
                    closeModal();
                    
                    // Reset form
                    consultationForm.reset();
                    // Reset to default state (phone tab selected)
                    if (phoneTab) phoneTab.checked = true;
                    if (phoneInput) phoneInput.classList.add('active');
                    if (emailInput) emailInput.classList.remove('active');
                    if (contactMethodInput) contactMethodInput.value = 'phone';
                    
                    // Re-enable submit button for next time
                    if (submitButton) {
                        submitButton.disabled = false;
                        submitButton.textContent = originalButtonText;
                    }
                    
                    // Show success toast
                    showToast('success', result.message || 'Thank you! We\'ll get back to you soon.');
                } else {
                    // Error - show error message in modal and scroll to top
                    const errorMessage = result.message || result.errors 
                        ? Object.values(result.errors).flat().join(', ') 
                        : 'Something went wrong. Please check your information and try again.';
                    showFeedbackMessage('error', errorMessage);
                    
                    // Scroll modal content to top
                    const modalForm = document.querySelector('.modal-form');
                    if (modalForm) {
                        modalForm.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                    
                    // Re-enable submit button
                    if (submitButton) {
                        submitButton.disabled = false;
                        submitButton.textContent = originalButtonText;
                    }
                }
            } catch (error) {
                // Hide loading overlay
                if (loadingOverlay) {
                    loadingOverlay.classList.remove('active');
                }
                
                // Network or other error - show in modal and scroll to top
                showFeedbackMessage('error', 'Unable to send your message. Please check your internet connection and try again.');
                
                // Scroll modal content to top
                const modalForm = document.querySelector('.modal-form');
                if (modalForm) {
                    modalForm.scrollTo({ top: 0, behavior: 'smooth' });
                }
                
                // Re-enable submit button
                if (submitButton) {
                    submitButton.disabled = false;
                    submitButton.textContent = originalButtonText;
                }
            }
        });
    }
    
    // Function to show feedback messages in the modal
    function showFeedbackMessage(type, message) {
        // Remove any existing message
        const existingMessage = document.getElementById('modal-feedback-message');
        if (existingMessage) {
            existingMessage.remove();
        }
        
        // Create message element
        const messageDiv = document.createElement('div');
        messageDiv.id = 'modal-feedback-message';
        messageDiv.className = `modal-feedback ${type}`;
        messageDiv.innerHTML = `
            <i class="fas fa-${type === 'success' ? 'check-circle' : 'exclamation-circle'}"></i>
            <span>${message}</span>
        `;
        
        // Insert before the form
        const modalForm = document.querySelector('.modal-form');
        if (modalForm && consultationForm) {
            modalForm.insertBefore(messageDiv, consultationForm);
        }
        
        // Fade in
        setTimeout(() => {
            messageDiv.style.opacity = '1';
        }, 10);
    }
    
    // Function to show toast notifications
    function showToast(type, message) {
        // Create toast container if it doesn't exist
        let toastContainer = document.getElementById('toast-container');
        if (!toastContainer) {
            toastContainer = document.createElement('div');
            toastContainer.id = 'toast-container';
            toastContainer.className = 'toast-container';
            document.body.appendChild(toastContainer);
        }
        
        // Create toast element
        const toast = document.createElement('div');
        toast.className = `toast toast-${type}`;
        toast.innerHTML = `
            <i class="fas fa-${type === 'success' ? 'check-circle' : 'exclamation-circle'}"></i>
            <span>${message}</span>
            <button class="toast-close" aria-label="Close">
                <i class="fas fa-times"></i>
            </button>
        `;
        
        // Add to container
        toastContainer.appendChild(toast);
        
        // Trigger animation
        setTimeout(() => {
            toast.classList.add('show');
        }, 10);
        
        // Auto-remove after 5 seconds
        const autoRemoveTimeout = setTimeout(() => {
            removeToast(toast);
        }, 5000);
        
        // Add click handler to close button
        const closeBtn = toast.querySelector('.toast-close');
        if (closeBtn) {
            closeBtn.addEventListener('click', () => {
                clearTimeout(autoRemoveTimeout);
                removeToast(toast);
            });
        }
    }
    
    // Function to remove a toast
    function removeToast(toast) {
        toast.classList.remove('show');
        setTimeout(() => {
            if (toast.parentNode) {
                toast.parentNode.removeChild(toast);
            }
            
            // Remove container if empty
            const toastContainer = document.getElementById('toast-container');
            if (toastContainer && toastContainer.children.length === 0) {
                toastContainer.remove();
            }
        }, 300);
    }
});
